import apiClient from './apiClient.js';

export const listCategories = () => apiClient.get('/categories');
export const getCategoryTree = () => apiClient.get('/categories/tree');
export const getCategory = (slug) => apiClient.get(`/categories/${slug}`);
export const getCategoryProducts = (slug, params = {}) =>
  apiClient.get(`/categories/${slug}/products`, { params });
export const createCategory = (data) => apiClient.post('/categories', data);
export const updateCategory = (id, data) => apiClient.put(`/categories/${id}`, data);
export const deleteCategory = (id) => apiClient.delete(`/categories/${id}`);
export const reorderCategories = (items) =>
  apiClient.patch('/categories/reorder', { items });
